import { PdfRewardsByAcademicYearList } from 'components/pdfStudent';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCreationRewards } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { creationRewardsSelector } from '../../../selectors';
import PdfCommonDataEntityContainer from '../dataEntityContainers/common';
import { splitRewardsByAcademicYear } from '../utils/splitRewardsByAcademicYear';

const PdfCreationRewardContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const studentRewards = useAppSelector(creationRewardsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().creationRewards });

  const hasData = studentRewards.content.length > 0;

  const academicYearData = splitRewardsByAcademicYear(studentRewards, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Награды и достижения" Icon={IconWidgetCreationRewards}>
      {hasData && <PdfRewardsByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCreationRewardContainer;
